import actionTypes from '../../utilities/actionTypes';

// Action Definition

export interface IFetchPlayoutUrlSuccess {
  type: actionTypes.FETCH_PLAYOUT_URLS_SUCCESS;
  feedCodes: string[];
  payload: any;
}
export interface IFetchPlayoutUrls {
  type: actionTypes.FETCH_PLAYOUT_URLS;
  feedCodes: string[];
  customers: string[];
}

export interface IFetchPlayoutUrlPending {
  type: actionTypes.FETCH_PLAYOUT_URLS_PENDING;
}

export interface IUpdatePlayoutFeeds {
  type: actionTypes.UPDATE_PLAYOUT_FEEDS;
  feeds: any;
}

export const fetchPlayoutUrlsPending = (): IFetchPlayoutUrlPending => {
  return { type: actionTypes.FETCH_PLAYOUT_URLS_PENDING };
};

export const fetchPlayoutUrlsSuccess = (
  payload: any,
  feedCodes: string[]
): IFetchPlayoutUrlSuccess => {
  return {
    type: actionTypes.FETCH_PLAYOUT_URLS_SUCCESS,
    payload,
    feedCodes
  };
};

export const fetchPlayoutUrls = (
  feedCodes: string[],
  customers: string[]
): IFetchPlayoutUrls => {
  return {
    type: actionTypes.FETCH_PLAYOUT_URLS,
    feedCodes,
    customers
  };
};

export const updatePlayoutFeeds = feeds => {
  return {
    type: actionTypes.UPDATE_PLAYOUT_FEEDS,
    feeds
  };
};
export type IPlayoutUrlAction =
  | IFetchPlayoutUrls
  | IFetchPlayoutUrlSuccess
  | IFetchPlayoutUrlPending
  | IUpdatePlayoutFeeds;
